<script setup>
import { Swiper, SwiperSlide } from 'swiper/vue';
import { Autoplay, EffectCoverflow, Navigation } from 'swiper/modules';

import 'swiper/css';
import 'swiper/css/effect-fade';
import 'swiper/css/navigation';
import 'swiper/css/pagination';
import SliderCard from "@/components/slider/SliderCard.vue";

const modules = [Autoplay, EffectCoverflow, Navigation];

const slides = [
  {
    title: "Real-Time Sports Betting ",
    text: "In-play and scheduled events with precision odds and real-time updates"
  },
  {
    title: "Casino Suite ",
    text: "A curated selection of slots, live dealer games, and classic casino experiences\n"
  },
  {
    title: "Virtual Competitions",
    text: "High-frequency, on-demand digital sports action"
  },
  {
    title: "Smart Wallet System",
    text: "Easy-to-use deposit and withdrawal processes with automated bonus tracking"
  }
]
</script>

<template>
  <div class="relative section-slider" v-motion :initial="{ opacity: 0 }" :visibleOnce="{ opacity: 1 }" :duration="700">
    <swiper
        :modules="modules"
        effect="coverflow"
        :navigation="{
          nextEl: '.swiper-button-next-custom',
          prevEl: '.swiper-button-prev-custom'
        }"
        :pagination="{ clickable: true }"
        :spaceBetween="50"
        class="slider"
        :loop="true"
        :speed="700"
        :autoplay="{ delay: 3000, disableOnInteraction: false }"
    >
      <swiper-slide v-for="(slide, index) in slides" :key="index">
        <SliderCard
            :title="slide.title"
            :text="slide.text"
        />
      </swiper-slide>
    </swiper>
    <div class="slider-controls flex absolute">
      <div class="swiper-button-prev-custom swiper-btn-prev flex align-center justify-center">
        <svg xmlns="http://www.w3.org/2000/svg" width="9" height="13" viewBox="0 0 9 13" fill="none">
          <path d="M2.32324 1.86269L6.93176 6.50019L2.32324 11.1377" stroke="#0E0E0E" stroke-width="3" stroke-linecap="round" stroke-linejoin="round"/>
        </svg>
      </div>
      <div class="swiper-button-next-custom swiper-btn-next flex align-center justify-center">
        <svg xmlns="http://www.w3.org/2000/svg" width="9" height="13" viewBox="0 0 9 13" fill="none">
          <path d="M2.32324 1.86269L6.93176 6.50019L2.32324 11.1377" stroke="#0E0E0E" stroke-width="3" stroke-linecap="round" stroke-linejoin="round"/>
        </svg>
      </div>
    </div>
    <div class="coin-3d-wrapper absolute">
      <div class="coin-tilt">
        <div class="coin-flip">
          <img src="../../assets/coin.png" class="coin-spin" alt="coin" />
        </div>
      </div>
    </div>
  </div>
</template>

<style scoped lang="scss">
.section-slider {
  width: clamp(410px, 43vw, 3100px);
  height: clamp(367px, 27vw, 2000px);
  .swiper {
    padding: clamp(5px, 0.3vw, 25px);
  }
  .slider-controls {
    gap: clamp(8px, 0.556vw, 40px);
    bottom: clamp(25px, 1.736vw, 125px);
    right: clamp(44px, 3.056vw, 220px);
    z-index: 2;
  }
  .coin-3d-wrapper {
    width: clamp(340px, 23vw, 1800px);
    height: clamp(280px, 19.444vw, 1400px);
    perspective: 1000px;
    top: -25%;
    right: -20%;
    z-index: 2;
  }

  .coin-tilt {
    width: 100%;
    height: 100%;
    transform-style: preserve-3d;
    animation: tiltX 4s ease-in-out infinite alternate;
  }

  .coin-flip {
    width: 100%;
    height: 100%;
    transform-style: preserve-3d;
    animation: flipTopBottom 5s ease-in-out infinite alternate;
  }
  .coin-spin {
    width: 100%;
    height: 100%;
    display: block;
    transform-style: preserve-3d;
    animation: spinY 6s linear infinite;
    filter: drop-shadow(0 0 5px rgba(0, 0, 0, 0.3));
  }
}
@keyframes spinY {
  from { transform: rotateY(0deg); }
  to   { transform: rotateY(360deg); }
}

@keyframes tiltX {
  from { transform: rotateX(-15deg); }
  to   { transform: rotateX(15deg); }
}

@keyframes flipTopBottom {
  from { transform: rotateX(0deg); }
  to   { transform: rotateX(180deg); }
}

@media (max-width: 768px) {
  .section-slider {
    width: 100%;
    .swiper {
      overflow: visible;
    }
    .slider-controls {
      right: 36px;
      bottom: 16px;
    }
    .coin-3d-wrapper {
      width: 200px;
      height: auto;
      right: -5%;
      top: -20%;
    }
  }
}
</style>
